import { render, staticRenderFns } from "./CampaignsDetail.vue?vue&type=template&id=55825a5c&scoped=true&lang=html"
import script from "./CampaignsDetail.vue?vue&type=script&lang=js"
export * from "./CampaignsDetail.vue?vue&type=script&lang=js"
import style0 from "./CampaignsDetail.vue?vue&type=style&index=0&id=55825a5c&prod&lang=scss"
import style1 from "./CampaignsDetail.vue?vue&type=style&index=1&id=55825a5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55825a5c",
  null
  
)

export default component.exports